import { createResource, useResource } from '@atlassian/react-resource-router';
import { fetchWorkflowBuilderProvisioning } from './services/index.tsx';

export const RESOURCE_TYPE_KEY = 'ADMIN_WORKFLOW_BUILDER_PROVISIONING';

export const workflowBuilderProvisioningResource = createResource<boolean>({
	type: RESOURCE_TYPE_KEY,
	getKey: () => RESOURCE_TYPE_KEY,
	getData: fetchWorkflowBuilderProvisioning,
	maxAge: 1000,
	isBrowserOnly: true,
});

export const useWorkflowBuilderProvisioning = () =>
	useResource<boolean>(workflowBuilderProvisioningResource);
